import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";
import "../src/style/Global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, Switch, Route, BrowserRouter, NavLink } from "react-router-dom";

import * as Yup from "yup";
import { isJson } from "./helpers/helpers";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faClock,
  faCheck,
  faBan,
  faEye,
  faEyeSlash,
  faHome,
  faUserCircle,
  faEdit,
  faSortUp,
  faSortDown,
  faSort,
  faAngleRight,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleDoubleLeft,
  faTrash,
  faTimes,
  faCalendarAlt,
  faTimesCircle,
  faRedo,
  faQuestionCircle,
  faPlus,
  faChevronUp,
  faChevronDown,
  faIdCard,
  faBars,
  faChartBar,
  faCalendarCheck,
  faUserNurse,
  faPaw,
  faPause
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSearch,
  faClock,
  faCheck,
  faBan,
  faEye,
  faEyeSlash,
  faHome,
  faUserCircle,
  faEdit,
  faSortUp,
  faSortDown,
  faSort,
  faAngleRight,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleDoubleLeft,
  faTrash,
  faTimes,
  faCalendarAlt,
  faTimesCircle,
  faRedo,
  faQuestionCircle,
  faPlus,
  faChevronUp,
  faChevronDown,
  faIdCard,
  faBars,
  faChartBar,
  faCalendarCheck,
  faUserNurse,
  faPaw,
  faPause


);

/**
 * Este es un método para validación personalizada de Yup
 * al estar en este archivo está disponible en toda la aplicación
 */
Yup.addMethod(Yup.string, "isJson", function (errorMessage) {
  return this.test("isJson", errorMessage, function (value) {
    const { path, createError } = this;

    return (
      value === "" ||
      isJson(value) ||
      createError({ path, message: errorMessage })
    );
  });
});

const PRODUCCION =
  process &&
  process.env &&
  process.env.REACT_APP_AMBIENTE &&
  process.env.REACT_APP_AMBIENTE === "produccion";

// En produccion no hay logs por consola
if (PRODUCCION) {
  console.log = function () { };
}

ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById("root"));
